import * as React from "react";
const SvgInboxAlt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 9.99992V11.8333C2.5 13.2334 2.5 13.9334 2.77248 14.4682C3.01217 14.9386 3.39462 15.3211 3.86502 15.5608C4.3998 15.8333 5.09987 15.8333 6.5 15.8333H13.5C14.9001 15.8333 15.6002 15.8333 16.135 15.5608C16.6054 15.3211 16.9878 14.9386 17.2275 14.4682C17.5 13.9334 17.5 13.2334 17.5 11.8333V9.99992M2.5 9.99992H5.5621C5.96975 9.99992 6.17357 9.99992 6.36539 10.046C6.53545 10.0868 6.69802 10.1541 6.84714 10.2455C7.01534 10.3486 7.15946 10.4927 7.44772 10.781L7.55229 10.8855C7.84054 11.1738 7.98466 11.3179 8.15286 11.421C8.30198 11.5124 8.46455 11.5797 8.63461 11.6205C8.82643 11.6666 9.03025 11.6666 9.4379 11.6666H10.5621C10.9697 11.6666 11.1736 11.6666 11.3654 11.6205C11.5354 11.5797 11.698 11.5124 11.8471 11.421C12.0153 11.3179 12.1595 11.1738 12.4477 10.8855L12.5523 10.781C12.8405 10.4927 12.9847 10.3486 13.1529 10.2455C13.302 10.1541 13.4646 10.0868 13.6346 10.046C13.8264 9.99992 14.0303 9.99992 14.4379 9.99992H17.5M2.5 9.99992L4.43866 5.69179C4.82294 4.83783 5.01508 4.41085 5.31688 4.09788C5.58367 3.82122 5.91065 3.6098 6.27242 3.48004C6.68168 3.33325 7.1499 3.33325 8.08634 3.33325H11.9137C12.8501 3.33325 13.3183 3.33325 13.7276 3.48004C14.0893 3.6098 14.4163 3.82122 14.6831 4.09788C14.9849 4.41085 15.1771 4.83783 15.5613 5.69179L17.5 9.99992",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgInboxAlt;
